import Vue from '@triotech/vue-core/src/vendor/vue';
import I18n from '@triotech/vue-core/src/lib/plugins/i18n';

const Translation = new Vue({
  i18n: I18n,
  data() {
    return {
      translations: {},
    };
  },
  async created() {
    const locale = this.fixLocale();
    this.translations = await this.getTranslations();
    await this.getTranslation(this.isLocaleAvailable(locale) ? locale : 'en_GB');
    this.$bus.$emit('ready');

    // TODO https://github.com/vue-generators/vue-form-generator/issues/352
    // this.$bus.$on('language-changed', this.getTranslation);

    this.$bus.$on('language-changed', this.setLocale);
    this.$bus.$on('language-changed', window.location.reload.bind(window.location));
  },
  methods: {
    fixLocale() {
      const locale = this.getLocale();
      return locale.indexOf('_') === -1 ? `${locale}_${locale.toUpperCase()}` : locale;
    },
    getLocale() {
      const locale = window.localStorage.getItem('locale');
      return locale || navigator.language.replace('-', '_');
    },
    async setLocale(locale) {
      window.localStorage.setItem('locale', locale);
    },
    async getTranslations() {
      return this.get('api/public/translation/');
    },
    async getTranslation(locale) {
      this.setLocale(locale);
      const translation = await this.get(`api/public/translation/${locale}`);
      // const translation = null;
      const i18nLocale = locale.slice(0, 2);
      this.$i18n.setLocaleMessage(i18nLocale, translation);
      this.$i18n.locale = i18nLocale;

      if (this.$moment.locale(locale) !== locale) {
        // eslint-disable-next-line console
        // console.warning(`Failed to apply moment locale ${locale}`);
      }
      this.loadRecaptcha(locale);
    },
    get(uri) {
      return this.$ajax.get(uri, null, { cancelToken: null });
    },
    isLocaleAvailable(locale) {
      return _.some(this.translations, (translation => translation.code === locale));
    },
    loadRecaptcha(lang) {
      const url = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${lang}`;
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.setAttribute('defer', '');
      document.head.appendChild(script);
    },
  },
});

Vue.set(Vue.prototype, '$translation', Translation);

export default Translation;



// WEBPACK FOOTER //
// ./src/plugins/translation.js